module.exports = __webpack_public_path__ + "ci_vendor_elastic.00527.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_elastic.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_elastic.svg
// module chunks = main